import styles from './CarrelloFooterActionsRow.module.scss';

export type CarrelloFooterActionsRowProps = {
  children?: React.ReactNode;
  className?: string;
  hasOnlyHorizontalPadding?: boolean;
};

export const CarrelloFooterActionsRow = ({
  children,
  className,
  hasOnlyHorizontalPadding,
}: CarrelloFooterActionsRowProps) => {
  return (
    <div
      className={`${styles.container} ${className && className} ${
        hasOnlyHorizontalPadding ? styles.hasOnlyHorizontalPadding : ''
      }`}
    >
      {children}
    </div>
  );
};
